import React from 'react';
import { AppContext, DocumentHomePage, DocPage } from '@component-controls/app';

var Layout = function Layout(_ref) {
  var docId = _ref.docId,
      storyId = _ref.storyId,
      activeTab = _ref.activeTab,
      category = _ref.category,
      type = _ref.type,
      docIndex = _ref.docIndex,
      Link = _ref.Link,
      Helmet = _ref.Helmet,
      store = _ref.store,
      children = _ref.children,
      userData = _ref.userData;
  return React.createElement(AppContext, {
    Helmet: Helmet,
    docId: docId,
    storyId: storyId,
    type: type,
    store: store,
    linkClass: Link,
    activeTab: activeTab,
    userData: userData
  }, children || (docIndex ? React.createElement(DocumentHomePage, {
    type: type
  }) : React.createElement(DocPage, {
    type: type,
    category: category
  })));
};

export { Layout };